import { Select, Modal } from 'antd';
import React, { useState } from 'react';

interface Props {
  appOptions: any[];
  selectAppList: string[];
  onClose: () => void;
  onChange: (appList: string[]) => void;
}
const ChangeAppModal: React.FC<Props> = (props: Props) => {
  const { appOptions, onClose, onChange, selectAppList } = props;
  const [appList, setAppList] = useState(selectAppList || []);

  const onAppChange = (values: any) => {
    setAppList(values);
  };
  const onSubmit = () => {
    onChange(appList);
  };
  return (
    <Modal
      visible={true}
      width={416}
      title="修改应用"
      onOk={onSubmit}
      onCancel={onClose}
      okButtonProps={{ disabled: !appList || appList?.length === 0 }}
      style={{ top: 200 }}
    >
      <div className="flex-ai-center">
        <span style={{ width: '40px' }}>应用</span>
        <Select
          mode="multiple"
          placeholder="请选择应用"
          value={appList}
          onChange={onAppChange}
          style={{ width: '100%' }}
          options={appOptions}
          showArrow
        />
      </div>
    </Modal>
  );
};

export default React.memo(ChangeAppModal);
